import styles from './card-actions.module.scss';

export const CardActions = ({ children, ...props }) => {
  return <section className={styles['btn-container']}>{children}</section>;
};
